import React from 'react'
import { FaFacebook, FaInstagram, FaYoutube , FaWhatsapp } from "react-icons/fa";

import logo from "../../assets/images/logo-trans.png"

function Footer() {

    function openWhatsApp() {
        window.open("https://wa.me/+919491065567", "_blank");
    }

  return (
    <div>
     

     <div class="footerarea">
            <div class="container">
                <div class="footerarea__newsletter__wraper">
                    <div class="row">
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 aos-init aos-animate" data-aos="fade-up">
                            <div class="footerarea__text">
                                <h3>Still You Need Our <span>Support</span> ?</h3>
                                <p>Don’t wait make a smart &amp; logical move today. Getting started is easy!</p>
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 aos-init aos-animate" data-aos="fade-up">
                            <div class="footerarea__newsletter">
                                <div class="footerarea__newsletter__input">
                                    <form action="#">
                                        <input type="text" placeholder="Enter your email here" required/>
                                        <div class="footerarea__newsletter__button">
                                            <button type="submit" class="subscribe__btn ">Request Assistance</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="footerarea__wrapper footerarea__wrapper__2 pb-0">
                    <div class="row">
            
                        <div class="col-xl-3 col-lg-3">
                            <div class="copyright__logo">
                                <a href="/"><img loading="lazy" src={logo} alt="logo" width="250px"/></a>
                            </div>
                            <div class="footerarea__content">
                                    <p>Trading Whales is a financial learning platform offering expert-led courses to help you navigate and master the stock market.</p>
                                </div>
                        </div>

                        <div class="col-xl-2 col-lg-2 col-md-6 col-sm-6 aos-init aos-animate" data-aos="fade-up">
                            <div class="footerarea__inner">
                                <div class="footerarea__heading">
                                    <h3>Quick Links</h3>
                                </div>
                                <div class="footerarea__list">
                                    <ul>
                                        <li>
                                            <a href="/">Home</a>
                                        </li>
                                        <li>
                                            <a href="/about">About</a>
                                        </li>
                                        <li>
                                            <a href="/why-us">Why Us</a>
                                        </li>
                                        <li>
                                            <a href="/gallery">Gallery</a>
                                        </li>
                                        <li>
                                            <a href="/contact">Contact</a>
                                        </li>
                                      
                                    </ul>
                                </div>


                            </div>
                        </div>
                        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-6 aos-init aos-animate" data-aos="fade-up">
                            <div class="footerarea__inner footerarea__padding__left">
                                <div class="footerarea__heading">
                                    <h3>Courses</h3>
                                </div>
                                <div class="footerarea__list">
                                    <ul>
                                      
                                        <li>
                                            <a href="/technical-analysis">Technical Analysis <span className='footer-anime-text'>Offline & Online</span> </a>
                                        </li>
                                        <li>
                                            <a href="/future-options">Futures & Options <span className='footer-anime-text'>Offline & Online</span></a>
                                        </li>
                                        <li>
                                            <a href="/advance-technical-analysis">Advance Technical Analysis <span className='footer-anime-text'>Offline & Online</span></a>
                                        </li>
                                        <li>
                                            <a href="/forex-trading">Forex Trading <span className='footer-anime-text'>Offline & Online</span></a>
                                        </li>
                                        <li>
                                            <a href="/advance-options-strategies">Advance Options Strategies <span className='footer-anime-text'>Offline & Online</span></a>
                                        </li>
                                    </ul>
                                </div>


                            </div>
                        </div>

               <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12 aos-init aos-animate" data-aos="fade-up">
                            <div class="footerarea__inner footerarea__about__us">
                                <div class="footerarea__heading">
                                    <h3>Join our trading community</h3>
                                </div>
                                <div class="footerarea__content">
                                    <p>Be part of our growing trader family. Stay informed, stay ahead.</p>
                                </div>
                              
                            </div>

                            <div className="footerarea__icon footerarea__icon__2">
  <ul>
  <li><a href="https://www.facebook.com/profile.php?id=61575582539320"  target='_blank'><FaFacebook /></a></li>
    <li><a href="https://www.instagram.com/trading_whaless/" target='_blank'><FaInstagram/> </a></li>
    <li><a href="https://www.youtube.com/channel/UC6YiqBS4VC3Xl9N4ruVVjvg" target='_blank'><FaYoutube/></a></li>
  </ul>
</div>

        </div> 

                    </div>
                </div>
                <div class="footerarea__copyright__wrapper footerarea__copyright__wrapper__2">
                    <div class="row">
                       
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                            <div class="footerarea__copyright__content footerarea__copyright__content__2 fw-bold">
                                <p>Copyright © 2025 <span>Trading Whales.</span> All Rights Reserved.</p>
                            </div>
                        </div>

                        <div className='col-xl-6 col-md-6 col-sm-6'>
                        <div class="footerarea__copyright__content footerarea__copyright__content__2 fw-bold d-flex justify-content-end align-items-center gap-4">
                                <p><span><a href="/terms" target='_blank'>TERMS & CONDITIONS</a></span></p>
                                <p><span><a href="/privacy"  target='_blank'>PRIVACY & POLICY</a></span></p>
                                <p><span><a href="/refund"  target='_blank'>REFUND POLICY</a></span></p>
                           
                            </div>
                        </div>
                        
                    </div>
                </div>

            </div>
        </div>




        {/* <!-- Whatsapp Fixed Icon start --> */}
<div class="pulse" onClick={openWhatsApp}>
    <a href="https://wa.me/+919491065567" target="_blank">
        <FaWhatsapp style={{marginTop:'-7px'}}/>
    </a>
</div>



{/* <!-- Whatsapp Fixed Icon end --> */}





    </div>
  )
}

export default Footer
